<!-- 彩票代表申请 -->
<template>
    <!-- 不绑定 v-loading：上传时的 loading 由 UploadCard 各自承担，不遮罩整个页面 -->
    <div class="biaodan">

        <el-form :model="form" :rules="rules" ref="form" label-width="160px">

            <el-form-item label="用户名/昵称:" prop="nickname">
                <el-input type="text" v-model="form.nickname" />
            </el-form-item>

            <el-form-item label="手机:" prop="phoneNumber">
                <el-input type="text" v-model="form.phoneNumber" maxlength="11" />
            </el-form-item>

            <el-form-item label="真实姓名:" prop="identityCardName">
                <div style="display:flex;align-items:center;">
                    <el-input type="text" v-model="form.identityCardName" style="width:200px;marginRight:20px" />
                    <span class="msg">一旦实名认证将不能修改，并且要和提现银行卡/微信/支付宝的姓名一致</span>
                </div>
            </el-form-item>

            <el-form-item label="身份证号:" prop="identityCardNo">
                <div style="display:flex;align-items:center;">
                    <el-input type="text" :maxlength="18" v-model="form.identityCardNo"
                        style="width:200px;marginRight:20px" />
                    <span class="msg">一旦实名认证将不能修改</span>
                </div>
            </el-form-item>

            <el-form-item label="入驻彩种:" prop="lotteryTypes">
                <el-select v-model="form.lotteryTypes" placeholder="请选择" style="width: 220px;">
                    <el-option v-for="item in select.arr" :key="item.roleId" :label="item.roleName"
                        :value="item.roleId">
                    </el-option>
                </el-select>
                <span class="msg" style="margin-left:10px;">一次只能选一个（暂时开放双色球、大乐透、）</span>
            </el-form-item>

            <!-- 彩票代表入驻个人说明 -->
            <el-form-item label-width="0">
                <textarea-block v-model="form.personalDescription" title="彩票代表入驻个人说明"
                    placeholder="请简单介绍一下您的彩票研究经历、擅长彩种、可提供的服务等" :maxlength="500" :rows="4" />
            </el-form-item>

            <!-- 身份证上传：正面 + 反面 并排 -->
            <el-form-item label="身份证上传:" required>
                <div class="upload-row">
                    <upload-card :preview="showImg.identityCardFront" title="身份证正面" tip="支持JPG、PNG格式" :width="150"
                        :height="170" :loading="uploadingField === 'identityCardFront'"
                        @change="e => chooseImg(e, 'identityCardFront')" @remove="removeImg('identityCardFront')" />

                    <upload-card :preview="showImg.identityCardBack" title="身份证反面" tip="支持JPG、PNG格式" :width="150"
                        :height="170" :loading="uploadingField === 'identityCardBack'"
                        @change="e => chooseImg(e, 'identityCardBack')" @remove="removeImg('identityCardBack')" />
                </div>
            </el-form-item>

            <!-- 头像上传：圆形 -->
            <el-form-item label="头像上传:" prop="avatar">
                <div class="upload-row">
                    <upload-card shape="circle" :preview="showImg.avatar" title="头像" tip="支持JPG、PNG" :width="130"
                        :height="130" :loading="uploadingField === 'avatar'" @change="e => chooseImg(e, 'avatar')"
                        @remove="removeImg('avatar')" />

                    <div class="upload-side-tip">
                        <p><i class="el-icon-info"></i> 支持 JPG、PNG 格式</p>
                        <p><i class="el-icon-picture"></i> 建议使用清晰的正面免冠照片</p>
                    </div>
                </div>
            </el-form-item>

            <el-form-item label="是否有60人以上彩票QQ群、微信群" label-width="260px" prop="groupChat">
                <el-input v-model="form.groupChat" type="text" placeholder="如果没有填无，如果有，说明QQ群号，微信号" />
            </el-form-item>

            <el-form-item label="是否是投注站站长：" prop="isBettingShopManager">
                <el-input v-model="form.isBettingShopManager" type="text" placeholder="如果没有填无，如果有，填报投注站信息" />
            </el-form-item>

            <el-form-item label="投注站地址：" prop="bettingShop">
                <el-input v-model="form.bettingShop" type="text" placeholder="请填写投注站详细地址" />
            </el-form-item>

            <el-form-item label="投注站编号：" prop="bettingShopNumber"
                :rules="{ required: true, message: '请输入投注站编号', trigger: 'change' }">
                <el-input v-model="form.bettingShopNumber" type="text" />
            </el-form-item>

            <!-- 双色球围4蓝10中7 -->
            <el-form-item label="是否最近10期双色球围4蓝10中7期:" label-width="260px" prop="isSsqWin10in7" v-if="showSsq">
                <div class="inline-group">
                    <upload-card small :preview="showImg.tenWinSevenFile" title="截图" :width="86" :height="86"
                        :loading="uploadingField === 'tenWinSevenFile'" @change="e => chooseImg(e, 'tenWinSevenFile')"
                        @remove="removeImg('tenWinSevenFile')" />

                    <span class="warn-msg">如果双色球围4蓝10中7，只能申请双色球彩票代表</span>
                </div>
            </el-form-item>

            <!-- 大乐透后区3围10中9 -->
            <el-form-item label="是否最近10期大乐透后区3围10中9期:" label-width="260px" prop="isDltWin10in9" v-if="showDlt">
                <div class="inline-group">
                    <upload-card small :preview="showImg.tenWinNineFile" title="截图" :width="86" :height="86"
                        :loading="uploadingField === 'tenWinNineFile'" @change="e => chooseImg(e, 'tenWinNineFile')"
                        @remove="removeImg('tenWinNineFile')" />

                    <span class="warn-msg">如果大乐透后区3围10中9，只能申请大乐透彩票代表</span>
                </div>
            </el-form-item>

            <el-form-item label="QQ号:" prop="qqNumber">
                <el-input type="text" v-model="form.qqNumber" style="width:200px;" />
                <span style="margin-left:40px;">微信号：</span>
                <el-input type="text" v-model="form.wechatNumber" style="width:200px;" />
            </el-form-item>

            <el-form-item label="钉钉号:" prop="dingTalkNumber">
                <el-input type="text" v-model="form.dingTalkNumber" style="width:300px;" />
                <span style="margin-left:30px;">性别：</span>
                <el-radio-group v-model="form.gender">
                    <el-radio label="0">男</el-radio>
                    <el-radio label="1">女</el-radio>
                    <el-radio label="2">保密</el-radio>
                </el-radio-group>
            </el-form-item>

            <!-- 分享一个我经历的彩票小故事 -->
            <el-form-item label-width="0">
                <textarea-block v-model="form.story" title="分享一个我经历的彩票小故事"
                    placeholder="说说你和彩票之间的故事，可以是中奖经历、研究心得、难忘的购彩瞬间……" :maxlength="800" :rows="5" />
            </el-form-item>

            <el-form-item label="最喜欢的彩票座右铭:" label-width="180px" prop="motto">
                <div style="display:flex;flex:1;">
                    <el-input type="text" placeholder="用一句话概括" v-model="form.motto" flex="1" />
                    <el-button type="primary" style="margin-left: 20px;"
                        @click="$refs.popupMotto.init()">选择座右铭</el-button>
                </div>
            </el-form-item>

            <el-form-item label="">
                <el-button type="primary" @click="submit" :loading="saveBtnLoading">确认</el-button>
            </el-form-item>
        </el-form>

        <motto ref="popupMotto" @confirm="e => this.form.motto = e" />
    </div>
</template>

<script>
import { representative_role_list, representativeApply } from '@/api/apply'
import motto from '@/components/motto/index.vue'
import baseApply from './baseApply.js'
import UploadCard from './UploadCard.vue'
import TextareaBlock from './TextareaBlock.vue'

export default {
    name: 'RepresentativeApply',
    components: { motto, UploadCard, TextareaBlock },
    mixins: [baseApply],
    computed: {
        // 根据已选入驻彩种，定位当前角色，用于决定是否显示对应中奖问答
        selectedRole() {
            const id = this.form.lotteryTypes
            if (id === '' || id == null || (Array.isArray(id) && id.length === 0)) return null
            return this.select.arr.find(item => item.roleId == id) || null
        },
        // 选了双色球才显示「双色球围4蓝10中7」问答
        showSsq() {
            return !!(this.selectedRole && /双色球/.test(this.selectedRole.roleName || ''))
        },
        // 选了大乐透才显示「大乐透后区3围10中9」问答
        showDlt() {
            return !!(this.selectedRole && /大乐透/.test(this.selectedRole.roleName || ''))
        },
    },
    methods: {
        // 入驻彩种选项来源：彩票代表专用列表
        roleApi() {
            return representative_role_list({ type: 'LOTTERY_REPRESENT' })
        },
        // 直接用接口返回数据，不再额外过滤
        filterRoleList(list) {
            return list || []
        },
        // 提交：彩票代表申请
        submitApi(data) {
            return representativeApply(data)
        },

        // ============ 测试数据（仅本地调试用，上线前删除） ============
        fillTestData() {
            Object.assign(this.form, {
                nickname: '测试彩票代表-何小乐',
                phoneNumber: '13131133772',
                identityCardName: '何小乐',
                identityCardNo: '13012119980605182X',
                groupChat: '有，QQ群号：987654321；微信群：test_wx_002',
                isBettingShopManager: '无',
                bettingShop: '河北省石家庄市长安区建设南大街99号',
                bettingShopNumber: 'BJ20260002',
                isSsqWin10in7: '0',
                isDltWin10in9: '0',
                qqNumber: '987654321',
                wechatNumber: 'test_wx_002',
                dingTalkNumber: 'dingtalk_002',
                gender: '1',
                personalDescription: '研究双色球5年，擅长走势分析与缩水，固定跟单彩民40余人',
                story: '曾经帮一位老彩民用缩水法省下不少投入，他也成了我的固定客户',
                motto: '理性购彩，快乐生活',
            })
        },
        // =============================================================
    },
    mounted() {
        // 等待 mixin 的 mounted（加载角色列表）执行完后再填测试数据
        this.$nextTick(() => {
            setTimeout(() => this.fillTestData(), 300)
        })
    }
};
</script>

<style lang="scss" scoped>
.upload-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
}

.upload-side-tip {
    color: #8a97a8;
    font-size: 13px;
    line-height: 1.9;

    p {
        margin: 0;
        display: flex;
        align-items: center;
        gap: 6px;
    }

    i {
        color: #5aa9ff;
        font-size: 14px;
    }
}

// 单选 + 上传截图 + 提示 同行
.inline-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;

    .upload-label {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        margin-left: 8px;
        color: #4a5a70;
        font-size: 14px;
        font-weight: 500;

        i {
            color: #1565d8;
            font-size: 15px;
        }
    }

    .warn-msg {
        color: #e08b3c;
        font-size: 13px;
        background: #fff7ea;
        border: 1px solid #ffe0b2;
        border-radius: 6px;
        padding: 5px 10px;
    }
}
</style>
